interface ProcessStepProps {
  number: number;
  title: string;
  description: string;
  variant?: "men" | "women";
}

const ProcessStep = ({ number, title, description, variant = "men" }: ProcessStepProps) => {
  return (
    <div className="flex gap-6 items-start group">
      <div className={`flex-shrink-0 w-16 h-16 rounded-full flex items-center justify-center font-serif text-2xl font-bold transition-all duration-300 group-hover:scale-110 ${
        variant === "men" 
          ? "bg-gradient-gold text-navy shadow-gold" 
          : "bg-gold/20 text-gold border-2 border-gold"
      }`}>
        {number}
      </div>
      <div className="flex-1 pt-2">
        <h3 className={`font-serif text-xl md:text-2xl font-bold mb-2 ${
          variant === "men" ? "text-navy" : "text-cream"
        }`}>
          {title}
        </h3>
        <p className={`text-base md:text-lg leading-relaxed ${
          variant === "men" ? "text-muted-foreground" : "text-cream/80"
        }`}>
          {description}
        </p>
      </div>
    </div>
  );
};

export default ProcessStep;
